import Button from '../components/Button';
import Icon from '../components/Icon';
import Switch from '../components/Switch';
import type { ImageUrls } from '../types/media';

type Props = {
  noCoverImage: boolean;
  coverImageUrls: ImageUrls | null;
  coverImageUploading: boolean;
  onToggleNoCoverImage: () => void;
  onUpload: (file: File) => void;
};

export default function CoverImageSection({
  noCoverImage,
  coverImageUrls,
  coverImageUploading,
  onToggleNoCoverImage,
  onUpload,
}: Props) {
  function triggerFilePicker() {
    (document.getElementById('cover-upload') as HTMLInputElement)?.click();
  }

  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full">
      <div className="flex justify-between items-center">
        <h3>Titelbild</h3>
        <div className="flex items-center gap-1">
          <span>Ohne</span>
          <Switch checked={noCoverImage} onChange={onToggleNoCoverImage} />
        </div>
      </div>

      {noCoverImage ? (
        <div
          className="border border-gray-tint-7 rounded-1_5 padding-3 flex items-center justify-center"
          style={{
            backgroundColor: 'var(--color-gray-tint-8, #f5f5f5)',
            minHeight: '80px',
          }}
        >
          <p style={{ color: 'var(--color-gray-tint-3, #888)', margin: 0 }}>
            Wähle nun eine Kategorie aus
          </p>
        </div>
      ) : coverImageUrls ? (
        <div className="flex flex-col gap-2 margin-top-1_5">
          <div className="image-preview-box">
            <img src={coverImageUrls.medium} alt="Titelbild Vorschau" />
          </div>
          <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
            Bild ersetzen
          </Button>
        </div>
      ) : (
        <div className="border border-gray-tint-7 rounded-1_5 padding-3 flex flex-col items-center justify-center gap-2">
          <p>
            {coverImageUploading
              ? 'Wird hochgeladen…'
              : 'Noch kein Bild hochgeladen'}
          </p>
          <Icon name="icon-upload" size={2} />
          {!coverImageUploading && (
            <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
              Bild hochladen
            </Button>
          )}
        </div>
      )}

      <input
        id="cover-upload"
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(file);
        }}
      />
    </div>
  );
}
